'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var closeSmall = require('./close-small-4f85c442.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
var paper = require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  position: fixed;\n  right: 0px;\n  bottom: 0px;\n  top: 0px;\n  left: 0;\n  font-family: ", ";\n  background: ", ";\n  backdrop-filter: blur(4px);\n  justify-content: center;\n  align-items: center;\n  padding: 24px;\n  display: ", ";\n"], ["\n  position: fixed;\n  right: 0px;\n  bottom: 0px;\n  top: 0px;\n  left: 0;\n  font-family: ", ";\n  background: ", ";\n  backdrop-filter: blur(4px);\n  justify-content: center;\n  align-items: center;\n  padding: 24px;\n  display: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colorsRgba.adminBlack_1;
}, function (_a) {
    var opened = _a.opened;
    return (opened ? 'flex' : 'none');
});
var StyledCloseSmall = styled__default(closeSmall.CloseSmall)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  cursor: pointer;\n  color: ", ";\n\n  &:hover, &:focus {\n    color: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  cursor: pointer;\n  color: ", ";\n\n  &:hover, &:focus {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedMediumGrey;
});
var StyledPaper = styled__default(paper.Paper)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  padding: 32px 32px 21px;\n  width: auto;\n  height: auto;\n  ", ";\n  max-height: 100%;\n  overflow: auto;\n  ", ";\n"], ["\n  position: relative;\n  padding: 32px 32px 21px;\n  width: auto;\n  height: auto;\n  ", ";\n  max-height: 100%;\n  overflow: auto;\n  ", ";\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && "max-width: " + maxWidth + "px";
}, function (_a) {
    var padding = _a.padding;
    return padding && "padding: " + padding + "px";
});
var Modal = function (_a) {
    var dataTestId = _a.dataTestId, _b = _a.opened, opened = _b === void 0 ? false : _b, _c = _a.withExitButton, withExitButton = _c === void 0 ? true : _c, maxWidth = _a.maxWidth, children = _a.children, onClose = _a.onClose, padding = _a.padding, _d = _a.closeOnOutsideClick, closeOnOutsideClick = _d === void 0 ? true : _d, restModalProps = tslib_es6.__rest(_a, ["dataTestId", "opened", "withExitButton", "maxWidth", "children", "onClose", "padding", "closeOnOutsideClick"]);
    var containerRef = React__default.useRef(null);
    var handleClickOutside = React__default.useCallback(function (event) {
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === event.target && closeOnOutsideClick) {
            event.stopPropagation();
            event.preventDefault();
            // eslint-disable-next-line no-unused-expressions
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [containerRef, onClose, closeOnOutsideClick]);
    return (React__default.createElement(Container, tslib_es6.__assign({ ref: containerRef, onClick: handleClickOutside, "data-testid": dataTestId + "-Container", opened: opened }, restModalProps),
        React__default.createElement(StyledPaper, { depth: 1, borderRadius: "sm", maxWidth: maxWidth, "data-testid": dataTestId && dataTestId, padding: padding },
            withExitButton && (React__default.createElement(StyledCloseSmall, { size: "lg", onClick: onClose, "data-testid": dataTestId + "-close" })),
            children)));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.Modal = Modal;
